import React from 'react';

const twocomponentsname = () => {
  return (
    <div className="second_data">
<h2>React js </h2>
<h3 className='third'>Java Script Learn.........</h3>




      
    </div>
  );
}

export default twocomponentsname;
